import React, { useEffect } from 'react';

import { Col, Row } from 'antd';
import { useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { paymentVerify } from '../../redux/payment/actions';
// import Loader from '../../components/loader/Loader';
// import paymentSuccess from '../../assets/payment-success.svg';
import paymentSuccess from '../../assets/payment-success.svg';
import paymentFailed from '../../assets/payment-failed.svg';

export default function PaymentStatus() {
  const language = useSelector((state) => state?.auth?.language);

  const [searchParams] = useSearchParams(); // Get query params
  const id = searchParams.get('id');
  // const pid = searchParams.get('pid');
  const dispatch = useDispatch();

  useEffect(() => {
    if (id) {
      dispatch(paymentVerify(id));
    }
  }, [id, dispatch]);

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100vw', height: '100vh' }}>
      <Row style={{ width: '100%', display: 'flex', justifyContent: 'center' }} gutter={[16, 16]}>
        <Col xs={24} md={8} lg={6} className="align-self-center text-center">
          <div className="mx-auto " style={{ margin: 'auto' }}>
            {true ? (
              <>
                <img src={paymentSuccess} alt="paymentSuccess img" className="img-fluid" />
                <div className="color-success payment-status-text">{language?.content?.PAYMENT_SUCCESS}</div>
              </>
            ) : (
              <>
                <img src={paymentFailed} alt="paymentFailed img" className="img-fluid" />
                <div className="color-danger payment-status-text">{language?.content?.PAYMENT_FAIL}</div>
              </>
            )}
          </div>
          <div className="pt-3">
            <a href={`/pay/${id}`} style={{ fontSize: '16px', color: '#007DFC', fontWeight: '600' }}>
              {language?.content?.BACK_TO_HOME || 'Back to home'}
            </a>
          </div>
        </Col>
      </Row>
    </div>
  );
}
